import { fetcher } from "helpers/fetcher";

import { TReorderTicketReq, TReorderTicketRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const reorderTicket = async (payload: TReorderTicketReq) => {
  return await fetcher<TReorderTicketRes, TReorderTicketReq["data"]>(
    ENDPOINT.MANAGEMENT.REORDER_TICKET,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.REORDER_TICKET.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: payload.urlData,
    }
  );
};

export const mutationReorderTicket = async (payload: TReorderTicketReq) => {
  return (await reorderTicket(payload)).data;
};

mutationReorderTicket._key = (payload: TReorderTicketReq) => [
  ENDPOINT.MANAGEMENT.REORDER_TICKET.url,
  payload,
];
